import { FinishConfiguration } from "../../components/FinishConfiguration/FinishConfiguration";

import { Fragment, type JSX, ReactNode } from "react";

import Alert from "@mui/material/Alert";
import { IndividualContainerProps } from "@plansoft-configuration-renderer/components";
import { CustomLayoutProps } from "@plansoft-configuration-renderer/layout";
import { useUiTranslator } from "@plansoft-configuration-renderer/localization";

export type ConfigurationContainerProps = {
  children: ReactNode;
} & CustomLayoutProps;

/**
 * Plain wrapper around the item
 */
export function CustomIndividualContainerMapper(
  props: IndividualContainerProps,
): JSX.Element {
  const t = useUiTranslator();
  const variant = props.variant;

  if (variant === "finishConfigurationTab") {
    return <FinishConfiguration children={props.children} />;
  }

  return (
    <Fragment>
      <Alert severity="warning">
        {t(
          "ConfigurationRenderer:componentNotSupported.IndividualContainer",
          "Individual containers are not supported by the default renderer and display only their content",
        )}
      </Alert>
      {props.children}
    </Fragment>
  );
}
